'use es6';

import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
import PropTypes from 'prop-types';
import { mapObject } from 'underscore';
import * as LayoutSections from 'DesignData/enums/LayoutSections';
import { LayoutWidget, UnifiedLayout } from 'DesignData/models/layouts';
import CssClassData from 'DesignData/models/css/CssClassData';
import * as LayoutEditableOptions from 'DesignData/enums/LayoutEditableOptions';
import * as LayoutWidgetEditableOptions from 'DesignData/enums/LayoutWidgetEditableOptions';
import LayoutWidgetEditableCSSOptions from 'DesignData/enums/LayoutWidgetEditableCSSOptions';
const layoutId = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const layout = PropTypes.instanceOf(UnifiedLayout);
const widget = PropTypes.instanceOf(LayoutWidget);
const templateType = PropTypes.number;
const selectedWidgets = PropTypes.shape({
  order: PropTypes.arrayOf(PropTypes.string).isRequired,
  widgets: PropTypes.objectOf(PropTypes.string).isRequired
});
const selectedWidgetsAsLayoutWidgets = PropTypes.shape({
  order: PropTypes.arrayOf(PropTypes.string).isRequired,
  widgets: PropTypes.objectOf(widget).isRequired
});
const cssClassData = PropTypes.instanceOf(CssClassData);
const layoutEditableOptions = PropTypes.shape(mapObject(LayoutEditableOptions, () => false));
const widgetEditableOptions = PropTypes.shape(mapObject(LayoutWidgetEditableOptions, () => false));
const widgetEditableCSSOptions = PropTypes.shape(mapObject(LayoutWidgetEditableCSSOptions, () => false));
const meta = PropTypes.shape({
  isBlog: PropTypes.bool,
  isCss: PropTypes.bool,
  isEmail: PropTypes.bool,
  isGlobalGroup: PropTypes.bool,
  isPage: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  categoryId: PropTypes.number,
  designAssetCategory: PropTypes.number,
  templateType: PropTypes.number
});
const layoutSection = PropTypes.oneOf(Object.keys(LayoutSections));
const layoutSectionHash = PropTypes.shape({
  widgets: PropTypes.object.isRequired,
  rows: PropTypes.object.isRequired
});
const layoutSectionData = PropTypes.shape({
  isHeaderEmpty: PropTypes.bool.isRequired,
  isBodyEmpty: PropTypes.bool.isRequired,
  isFooterEmpty: PropTypes.bool.isRequired,
  firstDelimiterId: PropTypes.string,
  firstDelimiterIndex: ReactUtilsPropTypes.uint32
});
export default {
  layoutId,
  layout,
  widget,
  selectedWidgets,
  selectedWidgetsAsLayoutWidgets,
  cssClassData,
  layoutEditableOptions,
  widgetEditableOptions,
  widgetEditableCSSOptions,
  meta,
  templateType,
  layoutSection,
  layoutSectionHash,
  layoutSectionData
};